import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconRocket2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRocket2"><Path d="M14.2028 21.5H9.79719C5.29292 14.5099 4.8409 8.30556 12 2.5C19.1591 8.30556 18.7071 14.5099 14.2028 21.5Z" stroke="currentColor"/><Path d="M6.5 11.5L3.5 15V20.5H9" stroke="currentColor"/><Path d="M17.5 11.5L20.5 15V20.5H15" stroke="currentColor"/><Circle cx="12" cy="12" r="1.75" stroke="currentColor"/></CentralIconBase>;
});

export default IconRocket2;
